import './LiksButton.css';

export type LiksButtonVariant = 'primary' | 'secondary' | 'danger';

export type LiksButtonProps = {
  variant?: LiksButtonVariant;
  fullWidth?: boolean;
  children: React.ReactNode;
  className?: string;
} & React.ComponentPropsWithoutRef<'button'>;

export function LiksButton({
  variant = 'primary',
  fullWidth = false,
  children,
  className,
  type = 'button',
  ...buttonProps
}: LiksButtonProps) {
  const classNames = [
    'liks-button',
    `liks-button--${variant}`,
    fullWidth && 'liks-button--full-width',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classNames} {...buttonProps}>
      {children}
    </button>
  );
}
